import { SearchIcon, ThumbsDownIcon, ThumbsUpIcon } from "lucide-react";
import { useEntityAction } from "~/components/providers/user-actions-provider";
import { Toggle } from "~/components/ui/toggle";
import { cn } from "~/lib/utils";
import { AddToListDropdown } from "../lists/add-to-list";

interface Props {
  id: string;
  onSearch: () => void;
  className?: string;
}

const OutfitButtons = ({ id, onSearch, className }: Props) => {
  const { reaction, takeAction } = useEntityAction(id, "OUTFIT");

  return (
    <div
      className={cn(
        "flex flex-row items-center justify-center gap-2 rounded-full p-1 shadow-md",
        "bg-background/50 text-secondary-foreground backdrop-blur-md",
        className,
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <Toggle size="icon" className="rounded-full" onPressedChange={onSearch}>
        <SearchIcon className="h-5 w-5" />
      </Toggle>
      <Toggle
        size="icon"
        pressed={reaction === "LIKE"}
        className="rounded-full"
        onPressedChange={() => takeAction("LIKE")}
      >
        <ThumbsUpIcon className="h-5 w-5" />
      </Toggle>
      <Toggle
        size="icon"
        pressed={reaction === "DISLIKE"}
        className="rounded-full"
        onPressedChange={() => takeAction("DISLIKE")}
      >
        <ThumbsDownIcon className="h-5 w-5" />
      </Toggle>
      <AddToListDropdown id={id} type="OUTFIT" />
    </div>
  );
};

export default OutfitButtons;
